import { ApiClient } from '@bustickus/api';
import { IClientVisaBrief } from '@bustickus/models-client';
import { createApiAddress } from 'common/helpers';

class ApiVisas {
  private readonly client: ApiClient = ApiClient.getInstance();
  private static instance: ApiVisas | null = null;

  private constructor() {}

  static getInstance(): ApiVisas {
    if (ApiVisas.instance == null) {
      ApiVisas.instance = new ApiVisas();
    }

    return ApiVisas.instance;
  }

  async getAll() {
    const address = createApiAddress(`/client/visas`);
    const response = await this.client.sendRequest<IClientVisaBrief[]>('get', address);
    return response;
  }
}

export default ApiVisas;
